export enum RoleEnum {
    Student = "Student",
    Trainer = "Trainer",
    Administrator = "Administrator",
    Seller = "Seller",
    CompanyManager = "CompanyManager"
}